(function($, Drupal){
  Drupal.behaviors.contactUsModal = {
    attach: function(context, settings) {
      $(document).on("dialogopen", ".giantrabbit-contact-modal", function(event, ui) {
        $('body').css('overflow', 'hidden');
        menu = $('.legacy-menu');
        if (!menu.hasClass('closed')) {
          menu.addClass('closed');
        }
      });
      $(document).on("dialogclose", ".giantrabbit-contact-modal", function(event, ui) {
        $('body').css('overflow', '');
      });
    }
  };
})(jQuery, Drupal);
